<template>
  <!-- <v-layout justify-center>
    <v-flex>
  
      <v-slide-y-transition mode="out-in"> -->
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>

                <v-toolbar dense prominent>
                  <v-toolbar-title>
                    JOB APPLICATION {{ current_req.length==0?'':' - ' + current_req[0].name + ' (' + current_req[0].status + ')' }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" small fab :href="'req_applicants_listing?uuid=d6754a7c-96b2-492f-81a4-f5eb3ec9ac7b&reqid=' + selected.req_id" v-on="on" v-if="is_mgr">
                          <v-icon>arrow_back</v-icon> 
                        </v-btn>
                      </template>
                      <span>Back to Applicant Listing</span>
                    </v-tooltip>
                  </v-toolbar-items>

                </v-toolbar>

                <v-card-text>
                  <!-- <v-container fluid ma-0 pa-0> -->
                    <v-layout row wrap>
                      
                      <v-flex xs12 md6>
                        <v-card-text>
                          <v-form ref="MainForm">
                            <v-container fluid ma-0 pa-0>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-text-field
                                    readonly
                                    :value="selected.req_id"
                                    label="#ID (Requisition)"
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                  <v-text-field
                                    readonly
                                    :value="selected._id"
                                    label="#ID"
                                  ></v-text-field>
                                </v-flex>
                              
                                <v-flex xs12>
                                  <v-text-field
                                    readonly
                                    :value="selected.name"
                                    label="Name"
                                  ></v-text-field>
                                </v-flex>
                              
                                <v-flex xs12>
                                  <v-text-field
                                    readonly
                                    :value="selected.username"
                                    label="Username"
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                  <v-text-field
                                    readonly
                                    :value="selected.contact_no"
                                    label="Contact No."
                                  ></v-text-field>
                                </v-flex>
                              
                                <v-flex xs12>
                                  <v-text-field
                                    readonly
                                    :value="selected.email"
                                    label="Email"
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs12 v-if="is_mgr">
                                  <v-textarea
                                    v-model="selected.remark"
                                    label="Remark"
                                    hint="Max 1000 characters."
                                  ></v-textarea>
                                </v-flex>

                              </v-layout>
                            </v-container>
                          </v-form>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="green" flat @click="save_onClick()" v-if="is_mgr" :disabled="!btnSave">
                            Save
                          </v-btn>
                        </v-card-actions>

                      </v-flex>

                      <v-flex xs12 md6>
                        <v-container fluid ma-0 pa-0>
                          <v-layout row wrap>

                            <v-flex xs6 sm4 lg3
                              class="pa-3"
                              v-for="(form, i) in selected.forms"
                              :key="i"
                            >
                              <v-card
                                @click="btn_onClick(form)"
                                style="cursor:pointer;"
                                :color="form.info.status?'success':'info'"
                                height="100%"
                              >
                                <v-card-text style="text-align: center; color: white">
                                  <div>
                                    <span><b>{{ form.info.form_name }}</b></span><br>
                                    <span style="font-size:medium"><b>{{ form.info.form_description }}</b></span><br><br>
                                    <span>{{ form.info.status?"Done":"New" }}</span>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                            
                          </v-layout>
                        </v-container>
                      </v-flex>

                    </v-layout>
                  <!-- </v-container> -->


                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      <!-- </v-slide-y-transition>
        
    </v-flex>
  </v-layout> -->
</template>
  
<script>
import auth from "../../functions/auth";
import common from "../../functions/general";

export default {
  name: "req_application_forms",
  data() {
    return {
      username: "",
      selected: {
        req_id: "",
				_id: "",
        name: "",
        username: "",
        email: "",
        contact_no: "",
        email_invi: null,
        email_info: {},
        email_log: [],
        forms: [],
        remark: "",
        g_status_id: "",
        created:0,
        created_by:"",
        modified:0,
        modified_by:"",
      },
      auth_role: false,
      form_list: [],
      btnSave: false,
      user_roles: [],
      is_mgr: false,
      current_req: []
    }
  },
  computed: {

  },
  watch: {
    "selected.remark": {
      handler: function() {
        this.btnSave = true;
      },
      // deep: true
    },
  },
  async mounted() {
    common.App.loader.show(this);
    common.App.set_page_title("mySuite: Req Forms");

    this.username = auth.getUsername();

    let temp = common.App.getQueryString("email_invi");
    this.selected.email_invi = temp!=null?parseInt(temp):null;

    this.selected.req_id = common.App.getQueryString("reqid");
    this.selected._id = common.App.getQueryString("_id");

    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
    res = res.data;
    if (res.Status == 1) {
      this.user_roles = res.Body;
    } else {
      common.wMsgBox.Error(res.Description);
    }

    res = await common.wBackEndComm.GetData("mycareer/requisition_listing/?_id=" + this.selected.req_id);
    res = res.data;
    if (res.Status == 1) {
      this.current_req = res.Body[0].records;
    } else {
      common.wMsgBox.Error(res.Description);
    }

    this.auth_role = common.App.check_role(this.user_roles, 7);

    await this.refreshData();

    this.btnSave = false;
    // // check is_mgr
    // if (this.auth_role && (this.selected.username != this.username)) {
    //   this.is_mgr = true;
    // }
  },
  created(){

  },
  methods: {
    get_URL(type) {
      let base = "";

      switch (type) {
        case "get":
          base = "mycareer/applicants_crud/?uuid=4fa09d2a-b89e-463e-9416-6c99118712c6&email_invi=";
          break;

        // case "post":
        //   base = "req_applicants_crud?pageid=227&email_invi=";
        //   break;

        // case "sendEmail":
        //   base = "req_email_invi?pageid=228&email_invi=";
        //   break;

        case "fillForm":
          base = "req_application_fill_forms?uuid=5efc4c51-96ea-427a-85e2-110fd801d9dd&email_invi=";
          break;
      }

      let temp = [
          base,
          this.selected.email_invi,
          "&reqid=",
          this.selected.req_id,
          "&_id=",
          this.selected._id
        ];
        temp = temp.join("");
      return temp;
    },
    async refreshData() {
      let res = await common.wBackEndComm.GetData(this.get_URL("get"));
      res = res.data;
      if (res.Status == 1) {
        this.selected = res.Body;
        this.selected.email = this.selected.email[0];
      } else {
        common.wMsgBox.Error(res.Description);
      }

      // check is_mgr
      if (this.auth_role && (this.selected.username != this.username)) {
        this.is_mgr = true;
      }

      common.App.loader.hide(this);
    },
    btn_onClick(form) {
      let url = this.get_URL("fillForm");

      let temp = [
        url,
        "&form_type=",
        form.type,
        "&form_id=",
        form.info.form_id,
        "&graph=",
        form.info.status
      ];
      
      window.location.href = temp.join("");
    },
    async save_onClick() {
			common.App.loader.show(this);

			if (this.$refs.MainForm.validate()) {
        // var new_rec = !this.selected._id;

        var postData = {
          "applicant_username": this.selected.username,
          "email_invi": this.selected.email_invi,
          "data": {
            "_id": this.selected._id ? this.selected._id:"",
            "remark": this.selected.remark
          }
        };
        
				var url = "mycareer/applicants_crud/";
				var result = await common.wBackEndComm.PostData(url, postData);
				result = result.data;

				if (result.Status == 1) {
					this.selected.modified = result.Body.modified;
          this.selected.modified_by = result.Body.modified_by;

          this.$nextTick(() => {
            this.btnSave = false;
          });

					common.wMsgBox.Success(result.Description);
				} else {
					common.wMsgBox.Error(result.Description);
				}
			} else {
				common.wMsgBox.Error(
					"Please fill in all required fields before click on save button."
				);
			}
			common.App.loader.hide(this);
    }
  }
};
</script>

<style>
</style>